// extracted by mini-css-extract-plugin
export var standaloneTable = "_i4-0";
export var standaloneTableWithBodyFill = "_i4-1";
export var withExtraHeader = "_i4-2";